module.exports = __webpack_public_path__ + "img/team-3.cd6b03a8.jpg";